import { render, staticRenderFns } from "./GoodsManagement.vue?vue&type=template&id=930338d6&scoped=true&"
import script from "./GoodsManagement.vue?vue&type=script&lang=js&"
export * from "./GoodsManagement.vue?vue&type=script&lang=js&"
import style0 from "./GoodsManagement.vue?vue&type=style&index=0&id=930338d6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./GoodsManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930338d6",
  null
  
)

export default component.exports